import apiRoutes from '../../../api-routes';
import { postRequest } from '../../../helpers/apiClient';
import { useMutationWithLogout } from '../../../hooks/useMutationWithLogout';

export const useValidatePassword = (options, token) => {
  return useMutationWithLogout(
    async ({ data }) =>
      postRequest({
        url: apiRoutes.VALIDATE_PASSWORD,
        data,
        headers: {
          Authorization: token ? token : sessionStorage.getItem('token'),
        },
      }),

    options,
  );
};
